import { useContext } from "react";
import useAPIRequest from "../../../../custom_hooks/simple/useAPIRequest";
import UiContext from "../../../../store/ui-context";

const useCRMNews = (props) => {
  const uiContext = useContext(UiContext);

  const { requestGetOne, loading } = useAPIRequest();

  const sendNotif = async ({ id }) => {
    await requestGetOne({
      fullUrl: `/api/crm/crmnews/send-notif/${id}`,

      onSuccess: ({ pagination, message, data }) => {
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };


  return {
    loading,
    sendNotif,
  };
};
export default useCRMNews;